import { render, staticRenderFns } from "./TodoListItem.vue?vue&type=template&id=20e9382e&"
import script from "./TodoListItem.vue?vue&type=script&lang=js&"
export * from "./TodoListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports